import { Component, Injectable } from "@angular/core";
import { AlertService } from "../../../shared/alert/services/alert.service";
import { UrlService } from "../../../shared/services/url.service";
import { SignalsService } from "../../services/signals.service";
import { Signal } from "../../models/Signal";
import { MatDialog } from "@angular/material";
import { ConfirmationModalComponent } from "./confirmationModal.component";
import { AssetsService } from "../../../shared/services/assets.service";
import { SignalsConfigurationService } from "../../services/signalsconfiguration.service";
import { SignalBoService } from "../../../shared/services/signalbo.service";
import { TradePosition } from "../../models/TradePosition";
import { SignalsMainComponent } from "./main.component";
import { SideBarService } from "../../../shared/services/sideBarService";
import { ValidationsService } from "../../services/validations.service";

@Component({
  selector: "app-signals",
  templateUrl: "../templates/signals.component.html"
})
@Injectable()
export class SignalsComponent extends SignalsMainComponent {
  title = "Signals";
  DashboardUrl = "";
  inProgress = true;
  sideValues = [
    { value: "BUY", text: "Buy" },
    { value: "SELL", text: "Sell" },
  ];
  MarketOrders = [
    {
      value: "short_term_fx",
      text: "Trading Idea FX Currencies",
      id: "Trading_Idea_FX",
    },
    {
      value: "short_term_commodities",
      text: "Trading Idea Commodities",
      id: "Trading_Idea_Commodities",
    },
    {
      value: "short_term_cryptocurrencies",
      text: "Trading Idea Cryptocurrencies",
      id: "Trading_Idea_Cryptocurrencies",
    },
    {
      value: "short_term_indices",
      text: "Trading Idea Indices",
      id: "Trading_Idea_Indices",
    },
    {
      value: "long_term_fx",
      text: "Long Term FX Currencies",
      id: "Long_Term_FX",
    },
    {
      value: "long_term_commodities",
      text: "Long Term  Commodities",
      id: "Long_Term_Commodities",
    },
    {
      value: "long_term_cryptocurrencies",
      text: "Long Term Cryptocurrencies",
      id: "Long_Term_Cryptocurrencies",
    },
    {
      value: "long_term_indices",
      text: "Long Term Indices",
      id: "Long_Term_Indices",
    },
    {
      value: "trade_plan",
      text: "Trade Plan",
      id: "Trade_Plan",
    },
    {
      value: "retest",
      text: "Retest",
      id: "Retest",
    },
  ];

  Assets = [];
  Signals: Signal[] = [];
  Servers = [];

  constructor(
    private assetsService: AssetsService,
    private urlService: UrlService,
    private signalsService: SignalsService,
    private signalBoService: SignalBoService,
    private alertService: AlertService,
    private configuration: SignalsConfigurationService,
    private dialog: MatDialog,
    private validationsService: ValidationsService,
    sideBarService: SideBarService
  ) {
    super(sideBarService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.Init();
  }

  private async loadPositions() {
    this.inProgress = true;

    const response = await this.signalBoService
      .GetPositions(
        false, this.MarketOrders.map((item) => item.id)
      )
      .toPromise();
    if (response) {
      response.forEach((item) => {
        var serverIndex = this.Servers.findIndex((server) => {
          return server.Name == item.serverName;
        });

        if (serverIndex < 0)
          this.Servers.push({ Name: item.serverName, Positions: [item] });
        else {
          this.Servers[serverIndex].Positions.push(item);
        }
      });
    }
    this.inProgress = false;
  }

  getStrategyPrefix(strategyId: string): string {
    var strategy = this.MarketOrders.find((item) => {
      return item.id == strategyId;
    });

    return strategy ? strategy.value : undefined;
  };

  GetStrategyName(strategyId: string): string {
    var strategy = this.MarketOrders.find((item) => {
      return item.id == strategyId;
    });

    return strategy ? strategy.text : undefined;
  };

  private async updatePosition(position: TradePosition) {
    var prefix = this.getStrategyPrefix(position.strategyId);
    if (!prefix) {
      this.alertService.add("danger", "Error getting strategy info.");
      return;
    }

    var signal: Signal = Object.assign({}, this.configuration.GetDefaultSignal());
    signal.Signal = "updateSignal";
    signal.Instrument = position.symbolName;
    signal.Side = position.side;
    signal.Strategy = this.getStrategyPrefix(position.strategyId);
    signal.Context = {
      positionMaintenanceId: position.positionMaintenanceId,
      takeProfitPrice: `${position.takeProfit}`,
      stopLossPrice: `${position.stopLoss}`,
    };

    this.signalsService.Create(signal).subscribe((response) => {
      this.inProgress = false;
      if (response)
        this.alertService.add("success", "Position successfully updated");
      else {
        this.alertService.add("danger", "Error on Position update");
      }
    });
  }

  async Init(): Promise<void> {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    let temp = this.configuration.GetDefaultSignal();
    this.Signals.push({
      ...temp, Context: {
        ...temp.Context
      }
    });
    this.Signals.push({
      ...temp, Context: {
        ...temp.Context
      }
    });
    this.Signals.push({
      ...temp, Context: {
        ...temp.Context
      }
    });
    this.assetsService
      .GetByFilter({
        name: "",
        providerId: this.configuration.GetQbitiaAssetProviderId(),
        type: "",
        isFollow: "",
        providerCode: "",
      })
      .subscribe(
        (result) =>
        (this.Assets = result.Assets.sort((a, b) =>
          a.Name > b.Name ? 1 : b.Name > a.Name ? -1 : 0
        ))
      );
    await this.loadPositions();
  }

  Create(signal: Signal): void {
    this.alertService.removeAll();
    if (this.isValidSignal(signal)) {
      signal.Instrument = signal.Instrument.toUpperCase();
      this.setCurrentTimeStamp(signal);
      this.dialog
        .open(ConfirmationModalComponent, {
          hasBackdrop: true,
          backdropClass: "fxstreet-modal-backdrop",
          panelClass: "fxstreet-preview-dialog-panel",
          position: { top: "150px" },
          data: {
            details: signal,
            title: "Create Signal",
            message: "Are you sure you want to create this signal?",
          },
        })
        .afterClosed()
        .subscribe((shouldCreate) => {
          if (shouldCreate) {
            this.inProgress = true;
            this.signalsService
              .Create(signal as Signal)
              .subscribe((response) => {
                this.inProgress = false;
                if (response)
                  this.alertService.add(
                    "success",
                    "Signal successfully created"
                  );
              });
          }
        });
    }
  }

  setCurrentTimeStamp(signal: Signal) {
    var diff = parseInt((new Date().getTime() / 1000).toFixed());
    signal.TimeStamp = diff;
  }

  isValidSignal(signal: Signal): boolean {
    var result = true;
    if (this.isNullOrWhiteSpace(signal.Signal)) {
      this.alertService.add("danger", "Please select an Action");
      result = false;
    }
    if (this.isNullOrWhiteSpace(signal.Side)) {
      this.alertService.add("danger", "Please select a Side");
      result = false;
    }
    if (this.isNullOrWhiteSpace(signal.Instrument)) {
      this.alertService.add("danger", "Please enter an Instrument");
      result = false;
    }
    if (this.isNullOrWhiteSpace(signal.Strategy)) {
      this.alertService.add("danger", "Please select a Market Order");
      result = false;
    }
    if (
      this.validationsService.hasInvalidLimits(
        signal.Side,
        Number(signal.Context.stopLossPrice),
        Number(signal.Context.takeProfitPrice)
      )
    ) {
      this.alertService.add(
        "danger",
        "Please check TakeProfit and StopLoss values. Some of them are invalid."
      );
      result = false;
    }

    return result;
  }

  isNullOrWhiteSpace(value: string): boolean {
    return value && value.trim() ? false : true;
  }

  SavePosition(position: any) {
    console.log(position);
    this.alertService.removeAll();
    if (
      this.validationsService.hasInvalidLimits(
        position.side,
        position.stopLoss,
        position.takeProfit
      )
    ) {
      this.alertService.add(
        "danger",
        "Please check EntryPrice, TakeProfit and StopLoss values. Some of them are invalid."
      );
      return;
    }
    this.dialog
      .open(ConfirmationModalComponent, {
        hasBackdrop: true,
        backdropClass: "fxstreet-modal-backdrop",
        panelClass: "fxstreet-preview-dialog-panel",
        position: { top: "150px" },
        data: {
          details: position,
          title: "Update Position",
          message: "Are you sure you want to update this position?",
        },
      })
      .afterClosed()
      .subscribe((shouldSave) => {
        if (shouldSave) {
          this.inProgress = true;
          this.updatePosition(position);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signals.component.ts